import React, { Component } from 'react';
import { Navigation } from '../../navigation/react-redux-nav';
import MuiRaisedButton from 'material-ui/RaisedButton';
import iFitLogo from './img/ifit-logo.svg';
import styles from '../../shared-styles';
import './index.css';

export default class IntroWolfPage extends Component {
  render() {
    return (
      <div className="intro-wolf-page">
        <img src={ iFitLogo } alt="iFit" />
        <div className="intro-content">
          <h1>Do more with your machine.</h1>
          <p>Get personalized workouts, led by world-class fitness trainers.</p>
          <Navigation.Forward>
            <div className="navigation-button-container">
              <MuiRaisedButton
                className="button"
                label="Get Started"
                primary={ true }
                fullWidth={ true }
                style={ styles.buttonStyle }
                buttonStyle={ styles.buttonBorderStyle }
                labelStyle={ styles.buttonLabelStyle }
              />
            </div>
          </Navigation.Forward>
        </div>
      </div>
    );
  }
}
